<template>
  <div v-bind="$attrs">
    <v-search
      :value="value"
      :items="res"
      :item-text="v => v.product_brand ? `(${v.product_brand}) ${v.name}` : v.name"
      item-value="id"
      :loading="loading"
      :required="required"
      :hint="hint"
      :search-input.sync="searchStr"
      placeholder="Search Products"
      :disabled="disabled"
      @search="search"
      @input="$emit('input', $event)"
      @select="select"
      @clear="clearResults"
      @valid-update="updateValidState"
    />
  </div>
</template>

<script>
import VSearch from '@/components/base/VSearch'

export default {
  props: {
    value: {
      type: [Number, String, Object],
    },
    selected: {
      type: Object
    },
    required: {
      type: Boolean
    },
    disabled: {
      type: Boolean
    },
    placeholder: {
      type: String,
      default: 'Search Products'
    },
    productCategoryId: {
      type: [String, Number]
    },
    productBrand: {
      type: String
    }
  },
  components: { VSearch },
  data() {
    return {
      loading: false,
      res: [],
      searchStr: '',
      isValid: false
    }
  },
  computed: {
    hint({ loading, searchStr, value, selected, res }) {
      if (loading) {
        return 'loading'
      } else if (searchStr == null || searchStr == '') {
        return 'Please enter your search terms'
      } else if (!!value && !!selected) {
        return null
      } else if (res.length == 0) {
        return 'No products found'
      } else {
        return null
      }
    }
  },
  created() {
    this.setInitialValue();
  },
  methods: {
    setInitialValue() {
      if (this.value && !this.selected) {
        this.$http.product.get(this.value).then(resp => {
          this.searchStr = resp.data ? resp.data.name : '';
          if (resp.data) {
            this.select(resp.data);
          }
        });
      }
    },
    search(v) {
      if(v) {
        this.loading = true;
        this.$http.products.get({
          q: v,
          product_brand: this.productBrand,
          product_category_id: this.productCategoryId
        }).then(resp => {
          this.res = resp.data.results;
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        });
      }
    },
    select(v) {
      this.$emit('update:selected', v);
    },
    clearResults() {
      this.res = [];
    },
    updateValidState(v) {
      this.isValid = v;
    }
  }
}
</script>

<style lang="scss" scoped>
.dropdown.is-fullwidth {
  width: 100% !important;
  .dropdown-trigger {
    width: 100%;
  }
}

.is-clickable {
  cursor: pointer;
  pointer-events: initial !important;
}
</style>
